import { Component, OnInit, Output, EventEmitter, HostListener, OnChanges, Input, SimpleChange, ViewChild } from '@angular/core';
import { ParamsMedia, FilterMedia, MaxSizesMedias, MediaTypeCode, eConfigKey, ParamsMediaModel } from '../../models';
import { ModalService } from '../../modal';
import { ToastService } from '../../toast';
import { DialogService } from '../../dialog';
import { TagComponent } from '../../tag';
import { MediaServiceV2 } from '../../services/media-v2.service';
import { UtilitiesService } from '../../services/utilities.service';
import { CoreService } from '../../services/core.service';

class CheckPreviews {
  public isOk: boolean;
  public ArrayPreviews: Array<PreviewsIndexSize>;
}

class PreviewsIndexSize {
  index: number;
  size: number;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-new-media-v2',
  templateUrl: './new_media_v2.component.html',
  styleUrls: ['./new_media_v2.component.css', '../media_v2.component.css'],
})

export class NewMediaV2Component implements OnInit, OnChanges {

  public media: ParamsMedia;
  public mediaPreviewsToDelete: Array<string>;
  public defaultName: string;
  public displayMedia: string | ArrayBuffer | null;
  public displayPreview: string | ArrayBuffer | null;
  public previewName: string;
  public ArrayTypes: Array<{ key: string; value: string }>;
  public maxSizesMedias: MaxSizesMedias = new MaxSizesMedias();
  /**
* format de l'image
* @example .png
*/
  public fileObj: File | null;
  public previewObjList: Array<File>;
  public accept: string;

  public showSlash = false;

  //  /**
  //* Player Plyr
  //*/
  //  public playerPlyr: any;

  @Input('updateMedia') updateMedia: ParamsMedia;
  @Input('restrictedTo') restrictedTo: FilterMedia;

  @Output() newMedia: EventEmitter<ParamsMedia> = new EventEmitter<ParamsMedia>();
  @Output() resetMedia: EventEmitter<ParamsMedia> = new EventEmitter<ParamsMedia>();
  @HostListener('drop', ['$event']) public onDrop(evt: any): void {
    evt.preventDefault();
    evt.stopPropagation();
    const files: File[] = evt.dataTransfer.files;
  }

  @ViewChild(TagComponent, { static: false }) tag: TagComponent;


  constructor(
    private dialogService: DialogService,
    private toast: ToastService,
    private mediaService: MediaServiceV2,
    private utilities: UtilitiesService,
    public modalService: ModalService,
    public coreService: CoreService,
  ) {

  }
  // #region CYCLE DE VIE
  ngOnChanges(changes: { [propKey: string]: SimpleChange }): void {
    this.UnselectMedia('Main');
    for (const propName in changes) {
      if (propName === 'updateMedia') {
        const _media: ParamsMedia = changes[propName].currentValue ? JSON.parse(JSON.stringify(changes[propName].currentValue)) : new ParamsMedia;
        this.media = _media;
        //this.playerPlyr = new Plyr('#plyrID', { captions: { active: true } });
      }
    }
  }

  ngOnInit(): void {
    this.maxSizesMedias.audio = Number(this.coreService.getConfigKey(eConfigKey.AUDIOSIZE));
    this.maxSizesMedias.document = Number(this.coreService.getConfigKey(eConfigKey.DOCSIZE));
    this.maxSizesMedias.image = Number(this.coreService.getConfigKey(eConfigKey.IMGSIZE));
    this.maxSizesMedias.video = Number(this.coreService.getConfigKey(eConfigKey.VIDEOSIZE));

    this.accept = this.restrictedTo.byType.audio ? '.mp3' : '';
    this.accept += this.restrictedTo.byType.document ? this.accept ? ', .pdf, .doc, .docx, .xlsx, .xlsm, .xlsb' : '.pdf, .doc, .docx, .xlsx, .xlsm, .xlsb' : '';
    this.accept += this.restrictedTo.byType.image ? this.accept ? ', .jpg, .jpeg, .png' : '.jpg, .jpeg, .png' : '';
    this.accept += this.restrictedTo.byType.video ? this.accept ? ', .mp4' : '.mp4' : '';
    this.previewObjList = new Array<any>();
    this.media = new ParamsMedia();
    this.displayMedia = '';
    this.displayPreview = '';
    this.mediaPreviewsToDelete = [];
    this.ArrayTypes = [
      { key: '------', value: '' },
      { key: 'image', value: MediaTypeCode.IMAGE },
      { key: 'vidéo', value: MediaTypeCode.VIDEO },
      { key: 'audio', value: MediaTypeCode.AUDIO },
      { key: 'document', value: MediaTypeCode.DOCUMENT }
    ];
  }
  // #endregion CYCLE DE VIE

  // #region METHODES PUBLIQUES
  public uploadMedia(): void {
    this.showSlash = true;
    let needToCreatePrev: boolean = false;
    if ((!this.previewObjList || this.previewObjList.length == 0) && this.media.PersonnalsPreviews.length > 0) {
      needToCreatePrev = true;
    }
    if (!this.fileObj && this.media.FullName && this.media.Path) {
      this.srcToFile(this.media.Path, this.media.FullName).then((res: File) => {
        this.fileObj = res;
        if (needToCreatePrev) {
          this.lstSrcToFiles(this.media.PersonnalsPreviews, this.media.FullName).then(() => {
            this.Upload();
          })
        } else {
          this.Upload();
        }
      });
    }
    else {
      if (needToCreatePrev) {
        this.lstSrcToFiles(this.media.PersonnalsPreviews, this.media.FullName).then(() => {
          this.Upload();
        })
      } else {
        this.Upload();
      }
    }
  }

  private Upload(): void {
    if (this.fileObj != null) {
      const nameSplit = this.fileObj.name.split('.');
      if (nameSplit.length > 1) {
        const file: File = this.createNewFile(`${this.media.Name}.${nameSplit[nameSplit.length - 1]}`, this.fileObj);

        const uploadIsReady: [boolean, number] = this.checkMediaSizes(file.size)
        if (uploadIsReady[0]) {
          const previewsSizesIsOk: CheckPreviews = this.checkPreviewsSizes(this.previewObjList);

          if (previewsSizesIsOk.isOk) {
            // sauvegarde du média
            this.mediaService.uploadMedia(file, !this.media.Ident || this.media.Ident == 0 ? '' : this.media.Ident.toString(), this.previewObjList).then(
              (res: ParamsMediaModel) => {
                this.showSlash = false;
                this.media = res.Value;
                this.newMedia.emit(this.media);
                this.cancelUpdate();
              })

          } else {
            let message: string = '';
            previewsSizesIsOk.ArrayPreviews.forEach((TooHeavyprev: PreviewsIndexSize) => {
              const mediaName: string = previewsSizesIsOk.ArrayPreviews.length > 1 ? `${this.previewObjList[TooHeavyprev.index]}: ` : '';
              message += `<br/> ${mediaName}${this.OptimizedDisplayOfMediaSize(TooHeavyprev.size)} > ${this.OptimizedDisplayOfMediaSize(this.maxSizesMedias.image)}`;
            });
            this.cancelUpdate();
            this.showSlash = false;
            this.toast.showAlertToast(`${this.coreService.getTrad('TooHeavyPreviewFile')}: ${message}`);
          }
        } else {
          this.cancelUpdate();
          this.showSlash = false;
          this.toast.showAlertToast(`${this.coreService.getTrad('TooHeavyFile')} : <br/>${this.OptimizedDisplayOfMediaSize(file.size)} > ${this.OptimizedDisplayOfMediaSize(uploadIsReady[1])}`);
        }
      } else {
        this.cancelUpdate();
        this.showSlash = false;
      }
    } else {
      this.cancelUpdate();
      this.showSlash = false;
    }
  }

  public cancelUpdate(): void {
    this.resetMedia.emit(undefined);
    this.media.Ident = 0;
    this.media.Path = '';
    this.media.Type = '';
    this.UnselectMedia('Main');
    this.UnselectMedia('Preview');
  }

  public UnselectMedia(type: string): void {

    switch (type) {
      case 'Main':
        this.displayMedia = '';
        this.fileObj = null;
        this.defaultName = '';
        this.media = this.media ? this.media : new ParamsMedia();
        this.media.NumberAutoPreviews = 0;
        this.media.Extension = '';
        this.media.Name = '';
        this.media.Type = '';
        break;
      case 'Preview':
        this.displayPreview = '';
        for (const personnalPreview of this.media.PersonnalsPreviews) {
          if (personnalPreview.includes('__P') && personnalPreview.includes('.png')) {
            const pathSplit: Array<string> = personnalPreview.indexOf('/') > -1 ? personnalPreview.split('/') : [personnalPreview];
            this.mediaPreviewsToDelete.push(pathSplit[pathSplit.length - 1]);
          }
        }
        this.media.PersonnalsPreviews = [];
        this.previewObjList = [];
        this.previewName = '';
        this.media.NumberPersonnalsPreviews = 0;
        this.media.PersonalsPreviewsSizes = [];
        break;
    }
  }

  public onSelectChange(e: any): void {
    this.UnselectMedia('Main');
    const file: File = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    this.AfficheImageBeforeUpload(file, 'media');
    const SplitFile: Array<string> = file.name.split('.');
    const extension: string = SplitFile[SplitFile.length - 1].toLowerCase();
    const extensionAccepted: Array<string> = this.accept.toLowerCase().replace(/\.| /g, '').split(',');
    if (extensionAccepted.includes(extension)) {
      this.fileObj = file;
      if (this.fileObj) {
        this.defaultName = this.fileObj.name ? this.fileObj.name.toLocaleLowerCase() : '';

        this.media.Extension = this.fileObj.name ? this.fileObj.name.split('.')[this.fileObj.name.split('.').length - 1].toLocaleLowerCase() : '';
        const iExtension: number = this.defaultName.lastIndexOf(this.media.Extension);
        this.media.FullName = file.name;
        this.media.Name = this.defaultName.slice(0, iExtension - 1);
        switch (this.media.Extension) {
          case 'pdf':
          case 'doc':
          case 'docx':
          case 'xlsx':
          case 'xlsm':
          case 'xlsb':
            this.media.Type = MediaTypeCode.DOCUMENT;
            break;
          case 'mp4':
            this.media.Type = MediaTypeCode.VIDEO;
            break;
          case 'jpg':
          case 'jpeg':
          case 'png':
            this.media.Type = MediaTypeCode.IMAGE;
            break;
          case 'mp3':
            this.media.Type = MediaTypeCode.AUDIO;
            break;
        }
      }
    } else {
      this.toast.showAlertToast(`${this.coreService.getTrad('InvalidFormat')} ${this.accept})`);
    }
  }

  public onPreviewChange(e: any): void {
    this.UnselectMedia('Preview');
    const file: File = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    this.AfficheImageBeforeUpload(file, 'preview');
    const SplitFile: Array<string> = file.name.split('.');
    const extension: string = SplitFile[SplitFile.length - 1].toLowerCase();
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      this.previewObjList = [e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0]];
      if (this.previewObjList) {
        this.previewName = this.previewObjList[0].name ? this.previewObjList[0].name : '';
        this.media.NumberPersonnalsPreviews = 1;
        this.media.PersonalsPreviewsSizes = [file.size];
      }
    } else {
      this.toast.showAlertToast(`${this.coreService.getTrad('InvalidFormat')} jpg, jpeg, png)`);
    }
  }

  public onDragOver(event: any): void {
    event.stopPropagation();
    event.preventDefault();
  }

  public AfficheZoomMediaModal(idModal: string): void {
    this.modalService.open(idModal);
  }

  // #endregion METHODES PUBLIQUES

  // #region METHODES PRIVEES

  private AfficheImageBeforeUpload(file: any, type: string): void {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (): void => {
      switch (type) {
        case 'media':
          this.displayMedia = reader.result;
          //this.playerPlyr = new Plyr('#plyrID', { captions: { active: true } });
          break;
        case 'preview':
          this.displayPreview = reader.result;
          break;
      }
    };
  }

  private createNewFile(newName: string, oldFile: File): File {
    // construction d'un nouveau File pour changer le nom de l'image par le nom saisi par l'utilisateur
    const blob: Blob = oldFile.slice(0, oldFile.size, oldFile.type);
    const file: File = new File([blob], newName, { type: oldFile.type });
    return file;
  }

  private checkPreviewsSizes(ArrayMediaObject: any): CheckPreviews {
    const result: CheckPreviews = new CheckPreviews();
    // vérification de la taille de toutes les previews
    result.isOk = true;
    // si previewObjList.length === 0 alors previewsSizesIsOk = true
    if (ArrayMediaObject.length > 0) {
      for (let i: number = 0; i < ArrayMediaObject.length; i++) {
        if (ArrayMediaObject[i].size > this.maxSizesMedias.image || ArrayMediaObject[i].size < 0) {
          result.isOk = false;
          const PrevIndexSize: PreviewsIndexSize = new PreviewsIndexSize();
          PrevIndexSize.index = i;
          PrevIndexSize.size = ArrayMediaObject[i].size;
          result.ArrayPreviews = new Array<PreviewsIndexSize>();
          result.ArrayPreviews.push(PrevIndexSize);
        }
      }
    }

    return result;
  }

  private checkMediaSizes(mediaSize: number): [boolean, number] {
    switch (this.media.Type) {
      case MediaTypeCode.IMAGE:
        return mediaSize <= this.maxSizesMedias.image && mediaSize > 0 ? [true, this.maxSizesMedias.image] : [false, this.maxSizesMedias.image];
      case MediaTypeCode.DOCUMENT:
        return mediaSize <= this.maxSizesMedias.document && mediaSize > 0 ? [true, this.maxSizesMedias.document] : [false, this.maxSizesMedias.document];
      case MediaTypeCode.AUDIO:
        return mediaSize <= this.maxSizesMedias.audio && mediaSize > 0 ? [true, this.maxSizesMedias.audio] : [false, this.maxSizesMedias.audio];
      case MediaTypeCode.VIDEO:
        return mediaSize <= this.maxSizesMedias.video && mediaSize > 0 ? [true, this.maxSizesMedias.video] : [false, this.maxSizesMedias.video];
      default:
        this.toast.showAlertToast(`${this.coreService.getTrad('InvalidFormat')} ${this.accept})`);
        return [false, 0];
    }
  }

  private OptimizedDisplayOfMediaSize(size: number): string {
    if ((size / 1048576) < 1) {
      if ((size / 1024) < 1) {
        return `${Math.round((size) * 100) / 100} octets`;
      } else {
        return `${Math.round((size / 1024) * 100) / 100} ko`;
      }
    } else {
      return `${Math.round((size / 1048576) * 100) / 100} Mo`;
    }
  }

  private lstSrcToFiles(src: string[], fileName: string): Promise<boolean> {
    const prev = src[src.length - 1];
    return this.srcToFile(prev, fileName).then((res: File) => {
      this.previewObjList = !this.previewObjList ? [] : this.previewObjList;
      this.previewObjList.push(res);
      if (src.length > 1) {
        return this.lstSrcToFiles(JSON.parse(JSON.stringify(src.pop())), fileName).then(() => { return true; });
      } else {
        return true
      }
    })
  }
  private srcToFile(src: string, fileName: string): Promise<File> {
    let blob: Blob = new Blob();
    return fetch(src).then(function (response) {
      return response.blob();
    }).then((resBlob: Blob) => {
      blob = resBlob;
      var b: any = blob;
      //A Blob() is almost a File() - it's just missing the two properties below which we will add
      b.lastModifiedDate = new Date();
      b.name = fileName;
      //Cast to a File() type
      return <File>blob;
    })
  }
}

